import { ReactNode } from "react"
import { Block, BlockProps, Spinner, useStyletron } from "@mezo-org/mezo-clay"

type FullContainerLoaderProps = BlockProps & {
  label: ReactNode
}

export default function FullContainerLoader({
  label,
  ...props
}: FullContainerLoaderProps) {
  const [css] = useStyletron()

  return (
    <Block
      className={css({
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      })}
      {...props}
    >
      <Spinner $size="xlarge" label={label} />
    </Block>
  )
}
